/**
 * afb-top管理外リンクコンポーネント
 */
import * as React from 'react'
import { BoxArrowUpRight } from 'react-bootstrap-icons'
import ExternalLink from '@components/link/ExternalLink/ExternalLink'
import { ExternalAfbTopLinks } from '@type/component-data-types'

type Props = ExternalAfbTopLinks & {
  type?: 'inline' | 'block' | 'list'
}

const ExternalAfbTopLink = (props: Props): React.JSX.Element => {
  const requiredCssClass = 'externalAfbTopLink'
  const updateProps = { ...props }

  props.className
    ? (updateProps.className = `${requiredCssClass} ${props.className}`)
    : (updateProps.className = `${requiredCssClass}`)

  if (props.type === 'inline') {
    updateProps.className = `${updateProps.className} isInline`
  } else if (props.type === 'list') {
    updateProps.className = `${updateProps.className} isList`
  }

  const externalLink = (
    <ExternalLink {...updateProps}>
      {props.children}
      <BoxArrowUpRight className="externalLink__icon" />
    </ExternalLink>
  )

  return props.type === 'inline' ? (
    externalLink
  ) : (
    <div className="externalAfbTopLinkWrap">{externalLink}</div>
  )
}

export default ExternalAfbTopLink
